
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"50","height":"50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25 2C12.316 2 2 12.316 2 25s10.316 23 23 23 23-10.316 23-23a23.082 23.082 0 00-5.313-14.719L41.5 8.875l-7.656 5.5 2.312 3.25 4.563-3.281A19.064 19.064 0 0144 25c0 10.477-8.523 19-19 19S6 35.477 6 25 14.523 6 25 6c3.531 0 7.063 1.004 10 2.844l3.313-2.625C34.53 3.489 29.797 2 25 2zm0 14c-4.96 0-9 4.04-9 9 0 4.965 4.04 9 9 9 4.965 0 9-4.035 9-9 0-4.96-4.035-9-9-9zm0 6a3 3 0 11-.002 6.002A3 3 0 0125 22z"}})])
          )
        }
      }
    